import { render, staticRenderFns } from "./internet.vue?vue&type=template&id=d5465920&scoped=true&"
import script from "./internet.vue?vue&type=script&lang=js&"
export * from "./internet.vue?vue&type=script&lang=js&"
import style0 from "./internet.vue?vue&type=style&index=0&id=d5465920&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5465920",
  null
  
)

export default component.exports